import type { ReactElement } from 'react';
import { PartyPopper, TriangleAlert } from 'lucide-react';
import { Confetti } from './Confetti';
import { promotionBonusDisplayStatus, promotionBonusText } from '../promotionBonusDisplay';
import type { PromotionBonusOutcome } from '../types';

/**
 * El bono de la promo de crédito como cerró en este tick. Solo el depositado celebra; FAILED no se
 * muestra y el ambiguo dice «en revisión».
 */
export function PromotionBonusBanner({
    bonus,
}: {
    bonus: PromotionBonusOutcome;
}): ReactElement | null {
    const display = promotionBonusDisplayStatus({ kind: 'CREDIT', status: bonus.status });
    if (display === null) return null;
    const paid = display === 'PAID';
    return (
        <div
            role="status"
            className={
                paid
                    ? 'relative overflow-hidden rounded-md border border-success-soft-border bg-success-soft px-3 py-2.5'
                    : 'relative overflow-hidden rounded-md border border-warning-soft-border bg-warning-soft px-3 py-2.5'
            }
        >
            {paid && <Confetti />}
            <div className="relative flex items-start gap-2 text-[12px] leading-relaxed">
                {paid ? (
                    <PartyPopper className="mt-px size-4 flex-none text-success" aria-hidden />
                ) : (
                    <TriangleAlert className="mt-px size-4 flex-none text-warning" aria-hidden />
                )}
                <span
                    className={paid ? 'font-semibold text-success' : 'font-semibold text-warning'}
                >
                    {promotionBonusText(display, bonus.amountCents)}
                </span>
            </div>
        </div>
    );
}
